import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import ListsHeader from "./headers/list-header";
import ListsTable from "./all-lists/lists-table";
import ListsSearch from "./all-lists/lists-search";
import ListsTableLoader from "./all-lists/lists-table-loader";
import { LOAD_LISTS } from "../../store/marketing/marketing-actions";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingListContainer",
  title() {
    return this.$t("sidebar.sections.marketingLists");
  },
  components: {
    ListsHeader,
    ListsSearch,
    ListsTable,
    ListsTableLoader
  },
  data() {
    return {
      loading: false
    };
  },
  computed: _objectSpread({}, mapState("MarketingStore", ["lists"])),
  watch: {
    $route(val) {
      if (val.name === "marketing-list") {
        this.getLists();
      }
    }
  },
  mounted() {
    this.getLists();
    Amplitude.logEvent("Lists - visited");
  },
  methods: _objectSpread(_objectSpread({}, mapActions("MarketingStore", [LOAD_LISTS])), {}, {
    async getLists() {
      this.loading = true;
      await this.LOAD_LISTS();
      this.loading = false;
    }
  })
});